import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '../../core/Components'
import SampleTable from '../../platform/explore/common/SampleTable'
import SongTable from '../../platform/explore/common/SongTable'
import StemTable from '../../platform/explore/common/StemTable'
import { DNATabLabels, DNATabsProps } from './DetailPageDNA'
import { SCROLL_TO_ID } from './DetailPageTopSection'

interface Props extends DNATabsProps {
  selectedTab: string
  clipArpIndexes?: number[]
}

const DNATable: FC<Props> = ({
  selectedTab,
  samplesUsed,
  stemsUsed,
  remixes,
  stemsFeaturedIn,
  songsFeaturedIn,
  clipArpIndexes
}) => {
  const navigate = useNavigate()

  const navigateToSamplePage = (id: number) => navigate(`/sample?token=${id}`)
  const navigateToStemPage = (id: number) => navigate(`/stem?token=${id}`)
  const navigateToSongPage = (id: number) => navigate(`/song?token=${id}`)

  return (
    <Box id={SCROLL_TO_ID}>
      {selectedTab === DNATabLabels.SAMPLES_USED && (
        <SampleTable
          data={samplesUsed}
          onSelect={navigateToSamplePage}
          selected={-1}
          clipArpIndexes={clipArpIndexes}
          hideRowPlayControls
        />
      )}
      {selectedTab === DNATabLabels.STEMS_USED && (
        <StemTable
          data={stemsUsed}
          onSelect={navigateToStemPage}
          selected={-1}
          hideRowPlayControls
        />
      )}
      {selectedTab === DNATabLabels.REMIXES && (
        <SongTable data={remixes} onSelect={navigateToSongPage} selected={-1} hideRowPlayControls />
      )}
      {selectedTab === DNATabLabels.STEMS_FEATURED_IN && (
        <StemTable
          data={stemsFeaturedIn}
          onSelect={navigateToStemPage}
          selected={-1}
          hideRowPlayControls
        />
      )}
      {selectedTab === DNATabLabels.SONGS_FEATURED_IN && (
        <SongTable
          data={songsFeaturedIn}
          onSelect={navigateToSongPage}
          selected={-1}
          hideRowPlayControls
        />
      )}
    </Box>
  )
}

export default DNATable
